import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../api/api";

import { Worker, Viewer } from "@react-pdf-viewer/core";
import { searchPlugin } from "@react-pdf-viewer/search";
import { zoomPlugin } from "@react-pdf-viewer/zoom";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";

const PROXY_URL =
  "https://ntactapi.brainymed.com/ntact/v1/forms/proxy?url=";

const withProxy = (url) =>
  url ? PROXY_URL + encodeURIComponent(url) : null;

const PublicManualDoc = () => {
  const [searchParams] = useSearchParams();
  const fileParam = searchParams.get("file");

  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const searchPluginInstance = searchPlugin();
  const zoomPluginInstance = zoomPlugin();
  
  const { ShowSearchPopover } = searchPluginInstance;
  const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

  const fetchfile = async () => {
    try {
      const response = await api.get(
        `/v1/documents/manual/search?file_name=${fileParam}`
      );
      const list = response?.data || [];

      const found = list.find((item) => item.file_name === fileParam);
      console.log("Search result:", list, "Found:", found);
      if (found) {
        const fullUrl = found.document_url;
        setPdfUrl(withProxy(fullUrl));
      } else {
        setPdfUrl(null);
      }
    } catch (error) {
      console.log(error);
      setPdfUrl(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (fileParam) fetchfile();
    else setLoading(false);
  }, [fileParam]);

  if (!fileParam) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="bg-white p-8 rounded-xl shadow text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            No file provided
          </h2>
          <p className="text-gray-500">
            Use: /print?file=HSE MANUAL SAFETY POLICY STATEMENT.pdf
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-600 animate-pulse">Loading PDF...</div>
      </div>
    );
  }

  if (!pdfUrl) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-white p-8 rounded-xl shadow text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">
            File not found
          </h2>
          <p className="text-gray-500">
            The requested manual does not exist.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen w-full flex flex-col">
      {/* Custom Toolbar */}
      <div className="bg-gray-100 border-b border-gray-300 p-3 flex items-center justify-end gap-3">
        <ShowSearchPopover />
        <div className="border-l border-gray-400 h-6 mx-2"></div>
        <ZoomOut />
        <CurrentScale />
        <ZoomIn />
      </div>

      {/* PDF Viewer */}
      <div className="flex-1 overflow-hidden">
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={pdfUrl}
            plugins={[searchPluginInstance, zoomPluginInstance]}
               defaultScale={1.0}
          />
        </Worker>
      </div>
    </div>
  );
};

export default PublicManualDoc;